<template>
  <modal class="paymentlayerModel" :isShow="isShow" @keyup.esc="hide">
    <div class="header">
        付款确认
        <div class="bnt_close" @click="hide()">关闭</div>
    </div>
    <div class="modal-body" ref="paymetMoney">
        <div class="amount-section">
            <div class="amount-row">
                <span class="amount-label">待支付金额：</span>
                <span class="amount-value"><span class="currency">¥</span><span id="totalAmount">{{Number(unPaidMoney).toFixed(2)}}</span></span>
            </div>
            <div class="notes" v-show="choicePayType.INTERFACE_TYPE==6 && maxPayMoney!=undefined">
                注:本单最大可用免单金额{{maxPayMoney}}元
            </div>
            <div class="payment-method">付款方式：<span class="tag">{{choicePayType.PAY_NAME}}</span></div>
        </div>
        <div class="pay-input-section">
            <div class="input-group change-group" :class="ChangMoney>0?'has-change':''" v-show="choicePayType.INTERFACE_TYPE==1">
                <span class="group-label">找零：</span>
                <div class="input-display"><span class="currency-sign">¥</span><span>{{Number(ChangMoney||0).toFixed(2)}}</span></div>
            </div>
            <div class="input-group pay-group">
                <span class="group-label">付款金额：</span>
                <div class="input-display">
                    <span class="currency-sign">¥</span>
                    <div class="input-money">
                        <div class="money-w">{{money||0}}</div>
                        <input-pattern class="input-m" ref="money" data-model='money' v-model="money" 
                            pattern="money"
                            :max="maxPayMoney"
                            @keyup.enter="inputCursor()"  
                            @focus="(e)=>e.target.select()"   />
                    </div>
                </div>
            </div>
        </div>


        
        <div class="keyboard">
            <div class="right-key">
                <table>
                    <tr>
                        <td><span class="key-quick" @click="setQuick(10)">¥10</span></td>
                        <td><span data-value="7">7</span></td>
                        <td><span data-value="8">8</span></td>
                        <td><span data-value="9">9</span></td>
                        <td><span data-value="clean" class="key-clear">C</span></td>
                    </tr>
                    <tr>
                        <td><span class="key-quick"  @click="setQuick(20)">¥20</span></td>
                        <td><span data-value="4">4</span></td>
                        <td><span data-value="5">5</span></td>
                        <td><span data-value="6">6</span></td>
                        <td><span data-value="back" class="key-back">⌫</span></td>
                    </tr>
                    <tr>
                        <td><span class="key-quick" @click="setQuick(50)">¥50</span></td>
                        <td><span data-value="1">1</span></td>
                        <td><span data-value="2">2</span></td>
                        <td><span data-value="3">3</span></td>
                        <td rowspan='2'><button class="key-confirm" @click="confirm()" v-throttle>确认</button></td>
                    </tr>
                    <tr>
                        <td><span class="key-quick"  @click="setQuick(100)">¥100</span></td>
                        <td><span data-value=".">.</span></td>
                        <td><span data-value="0">0</span></td>
                        <td><span data-value="00">00</span></td>
                    </tr>
                </table>
            </div>
        </div>
    </div>
  </modal>
</template>

<script>
import {initKeyBoard} from '/src/common' 

/**会员支付 */
export default {
    name:"paymentlayerModel",
    props:{
        isShow:Boolean,
        unPaidMoney:Number,
        choicePayType:Object,
        /**订单 金额信息 */
        totalOrderMoney:{
            type:Object,
            default:null
        }
    },
    data(){
        return {
            money:'',
            ChangMoney:'',
            userInfo:null
        }
    },
    mounted(){
        this.userInfo=this.$auth.getUserInfo(); //获取用户id
        this.$nextTick(()=> {
            initKeyBoard.call(this,this.$refs.paymetMoney,this.$refs.money.$el);
            this.money =  Number((Number(this.unPaidMoney)).toFixed(2))
            //this.number=this.disRadioOrder?.Eat_Number;
            this.EmptyDatas()
        })
    },
    computed:{
        /**支付金额最大可输入多少 */
        maxPayMoney(){
            if(this.choicePayType?.INTERFACE_TYPE==6){//支付类型为免单时
                let freeMoney=this.userInfo?.LimitedFreeMoneyOfEachBill||0;
                if(this.userInfo?.LimitedFreeMoneyOfEachBillType==1){//金额 
                    return freeMoney;
                }else if(this.userInfo?.LimitedFreeMoneyOfEachBillType==2){//折前消费金额%
                    return Number(this.totalOrderMoney.sumMoney).compute((freeMoney/100),'*');
                }else if(this.userInfo?.LimitedFreeMoneyOfEachBillType==3){//折后消费金额%
                    return Number(this.totalOrderMoney.totalMoney).compute((freeMoney/100),'*');
                }
            }
            return null;
        }
    },
    watch: {
        //用于观察数据变动。对应一个对象,键是观察表达式,值是对应回调。子组件中 需要结合watch监听
        isShow() { 
            this.EmptyDatas();
        },
        money(){
            if(this.money>Number((Number(this.unPaidMoney)).toFixed(2))){
                this.ChangMoney = Number(Number(this.money - this.unPaidMoney).toFixed(2))
            }else{
                this.ChangMoney=''
            }
        },
    },
    methods:{
        /**默认input焦点 */
        EmptyDatas(){
            setTimeout(() => {
                this.$refs.money.focus();
            },100);
        },
        inputCursor(){
            this.confirm();
        },
        hide(){
            this.$emit("closeModel")
        },
        setQuick(money){
            this.money=money;
        },
        /**确定和回车事件 */
        confirm(){
            if(Number(this.money)>=0){
                this.$emit('cashConfirm',this.money);
            }else{
                this.$message.warning("付款金额必须大于0!");
                return
            }
            
        },
    }
}
</script>

<style lang="sass">
@import "./paymentlayerModel.scss";
</style>